import { Model, View } from '@lernetz/ts-lib';

import type { AnswerBase } from './AnswerBase';
import template from './Answer.html';

type AnswerType = '-single-choice' | '-multiple-choice';

export class Answer extends Model implements AnswerBase {

    public readonly correct: boolean;
    public correctlyAnswered: boolean;
    public evaluated: boolean;
    public selected: boolean;
    public text: string;
    public type: AnswerType;

    public constructor( dto ) {
        super( {
            correct: false,
            correctlyAnswered: false,
            evaluated: false,
            selected: false,
            text: '',
            ...dto,
        } );

        this.updateState();
    }

    public toggle() {
        if( this.evaluated ) return;
        this.selected = this.type === '-single-choice' || !this.selected;
        this.updateState();
    }

    private updateState() {
        this.correctlyAnswered = this.selected == this.correct;
    }
}


export class AnswerView extends View<Answer> {

    constructor() {
        super({ template });
    }
}
